import axios from 'axios'
import {AuthModel, UserModel} from './_models'

export const FAST_API_URL = 'https://de-python-backend-d7bpbkdvgggmd5gj.eastus-01.azurewebsites.net'
// export const FAST_API_URL = 'http://localhost:8000'

 export const API_URL = 'https://de-dashboard-be.azurewebsites.net'
//export const API_URL = 'http://localhost:4000'
export const LOCAL_API_URL = 'http://localhost:4000'

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/users/verify_token`
export const LOGIN_URL = `${API_URL}/users/login`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`
export const PULL_AMAZON_BRAND_DATA = `${API_URL}/amazon-scout/login`
export const REFRESH_TOKEN_URL = `${API_URL}/users/refresh_token`

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    token: token,
  })
}

export function refreshToken(token: string) {
  return axios.post<AuthModel>(REFRESH_TOKEN_URL, {
    token: token,
  })
}
